/** 첨부 파일을 순서대로 업로드하고 성공한 이미지 URL을 반환한다. */
export async function uploadErrorNoteAttachments(
  files: File[],
  uploadFile: (file: File) => Promise<string | null>,
): Promise<string[]> {
  const uploadedUrls: string[] = [];
  for (const file of files) {
    const url = await uploadFile(file);
    if (url) uploadedUrls.push(url);
  }
  return uploadedUrls;
}
